import { defineComponent, openBlock, createBlock, unref, withCtx, createVNode, createElementVNode, createTextVNode, createCommentVNode } from "vue";
import { CdrBanner, IconWarningStroke, CdrLink, IconExternalLink } from "@rei/cedar";
const _hoisted_1 = {
  class: "ship-urgency__message"
};
const _hoisted_2 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxShipUrgency",
  props: {
    message: {
      default: ""
    },
    showShipUrgencyLink: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(CdrBanner), {
        type: "warning",
        class: "ship-urgency"
      }, {
        "icon-left": withCtx(() => [createVNode(unref(IconWarningStroke))]),
        default: withCtx(() => [createElementVNode("div", _hoisted_1, [createElementVNode("span", {
          class: "ship-urgency__message-text",
          innerHTML: _ctx.message
        }, null, 8, _hoisted_2), _cache[2] || (_cache[2] = createTextVNode("  ")), _ctx.showShipUrgencyLink ? (openBlock(), createBlock(unref(CdrLink), {
          key: 0,
          class: "ship-urgency__message-link",
          href: "/help/shipping-timelines.html",
          target: "_blank"
        }, {
          default: withCtx(() => [_cache[0] || (_cache[0] = createTextVNode(" Learn More ")), _cache[1] || (_cache[1] = createElementVNode("span", {
            class: "pdp-sr-only"
          }, " (Opens in a new window)", -1)), createVNode(unref(IconExternalLink), {
            "inherit-color": "",
            class: "ship-urgency__icon-external",
            size: "small"
          })]),
          _: 1
        })) : createCommentVNode("", true)])]),
        _: 1
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxShipUrgency2.mjs.map
